import Reviews from "./Reviews";
import useProductShowReviews from "@/hooks/product-reviews/useProductShowReviews";

const ExpertReviews = ({ productReviews }) => {
  const { isLoading, data, showMoreHandler } = useProductShowReviews(
    productReviews?.pro_review_url
  );

  return (
    <Reviews
      isLoading={isLoading}
      data={data}
      onClickShowMore={showMoreHandler}
    />
  );
};

export default ExpertReviews;
